import { createContext } from 'react';
import { NOOP } from './constant';
export var FormContext = createContext({
    layout: 'vertical',
    maintainRawRules: false,
    labelCol: { span: 7, offset: 0 },
    labelAlign: 'left',
    wrapperCol: { span: 17, offset: 0 },
    closeColumns: false,
    columnsNum: 1,
    columnsGutter: 16,
    optional: false,
    requiredSymbol: false,
    getFormElementId: function () { return 'arco-'; },
    store: {
        getFieldsValue: NOOP,
        getFieldValue: NOOP,
        getFieldError: NOOP,
        getFieldsError: NOOP,
        getTouchedFields: NOOP,
        getFields: NOOP,
        setFieldValue: NOOP,
        setFieldsValue: NOOP,
        setFields: NOOP,
        resetFields: NOOP,
        submit: NOOP,
        validate: NOOP,
        scrollToField: NOOP,
        getInnerMethods: function () { return ({
            registerField: NOOP,
            innerGetStore: NOOP,
        }); },
    },
});
export var FormItemContext = createContext({
    formItemAlone: true,
});
export var FormProviderContext = createContext({});
export var FormListContext = createContext({});
